export const isMobile = () => {
  if (typeof window !== 'undefined') {
    return Boolean(
      window.matchMedia('(pointer:coarse)').matches ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)
    )
  }

  return false
}

export const isWebView = () => {
  if (typeof window === 'undefined') {
    return false
  }

  var rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari)',
    'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
    'Linux; U; Android',
  ]

  var webviewRegExp = new RegExp('(' + rules.join('|') + ')', 'ig')

  return !!navigator.userAgent.match(webviewRegExp)
}
